export const globalTrackerModule = {
  namespaced: true,
  state: {
    filters: {
      filterProjectId: "",
      filterMilestoneBoardId: "",
      filterDepartmentId: "",
      filterAssigneeId: "",
      filterDepartmentAssigneeId: "",
      filterSupervisorId: "",
      filterTaskStatus: "",
      filterDeadline: "",
      filterActualEndDate: "",

    },
  },
  getters: {
    getFilters: function (state) {
      return state.filters;
    },
  },
  mutations: {
    setFilter: function (state, payload) {
      state.filters[payload.key] = payload.value;
    },
    resetFilters: function (state) {
      // Reset each filter to its default value (in this case, an empty string)
      state.filters = {
        filterProjectId: "",
        filterMilestoneBoardId: "",
        filterDepartmentId: "",
        filterAssigneeId: "",
        filterDepartmentAssigneeId: "",
        filterSupervisorId: "",
        filterTaskStatus: "",
        filterDeadline: "",
        filterActualEndDate: "",
      };
    },
  },
  actions: {
    setFilter: function (context, payload) {
      // Pass both key and value in the payload
      context.commit("setFilter", {
        key: payload.key,
        value: payload.value,
      });
    },
    resetFilters: function (context) {
      context.commit("resetFilters");
    },
  },
};
